import { graphql } from '@/generated/gql';

export const INTAKE_CHAT_REQUEST_DESCRIPTION = graphql(/* GraphQL */ `
  query IntakeChatRequestDescription($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        requestDescription {
          id
          text
          language
        }
      }
    }
  }
`);
